import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box, Tabs, Tab, Button, IconButton } from "@mui/material";
import React from "react";
import CustomerList from "../../features/manageCustomers/customerList";
import CustomerTopbar from "../../features/manageCustomers/topbar";
import CustomerListPending from "../../features/manageCustomers/customeListPending";
import SearchBar from "../../components/SearchBar";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import IosSwitchMain from "../../components/iosSwitchMain";
import FilterMenu from "../../components/filterMenu";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageEmployee = () => {
  const navigate = useNavigate();

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const rows = [
    {
      id: 1,
      email: "abdul@sample.com",
      phone: "+971 (0) 567894623",
      memberType: "Single",
      createdDate: "18 - June - 2025 | 6:00PM",
    },
    {
      id: 2,
      email: "abdul@sample.com",
      phone: "+971 (0) 567894623",
      memberType: "Duo",
      createdDate: "18 - June - 2025 | 6:00PM",
    },
    {
      id: 3,
      email: "abdul@sample.com",
      phone: "+971 (0) 567894623",
      memberType: "Single",
      createdDate: "18 - June - 2025 | 6:00PM",
    },
    {
      id: 4,
      email: "abdul@sample.com",
      phone: "+971 (0) 567894623",
      memberType: "Duo",
      createdDate: "18 - June - 2025 | 6:00PM",
    },
    {
      id: 5,
      email: "abdul@sample.com",
      phone: "+971 (0) 567894623",
      memberType: "Single",
      createdDate: "18 - June - 2025 | 6:00PM",
    },
  ];
  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 140,
      field: "name",
      headerName: "Name",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div
            className="user_block click_action"
            onClick={() => navigate("/manage-employee/view")}
          >
            <figure>
              <img src="/static/images/user_placeholder.png" alt="" />
            </figure>
            <p>
              <b>Madelyn Dias</b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 170,
      field: "email",
      headerName: "Email",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 140,
      field: "phone",
      headerName: "Phone No.",
      editable: false,
      sortable: false,
    },
   
    {
      field: "action",
      headerName: "Action",
      minWidth: 130,
      renderCell: () => {
        return (
          <div className="table_actions v2">
            <IconButton className="toggle_btn" >
              {" "}
              <IosSwitchMain />{" "}
            </IconButton>
            <IconButton className="edit_icon" onClick={()=> navigate('/manage-employee/add')}>
              {" "}
              <img src="/static/images/edit_icon.svg" alt="icon" />{" "}
            </IconButton>
          </div>
        );
      },
    },
  ];
  let hidden = ["fullName"];

  return (
    <MainContainer>
      <div className="main_title d_flex">
        <h1>Employee Management</h1>

        <div className="right_s">
          <SearchBar searchTerm={""} placeholder={"Search "} />
          <Button className="btn btn_primary" onClick={()=> navigate('/manage-employee/add')}>+ Add New Employee</Button>
         <FilterMenu />
        </div>
      </div>

      <div className="table_wraper">
        <div className="sorting_table">
          <TableComponent
            columns={columns?.filter((item) => !hidden.includes(item.field))}
            rows={rows}
          />
        </div>
      </div>
    </MainContainer>
  );
};

export default ManageEmployee;
